import React from 'react';

import AuthContext from 'src/features/auth/context/AuthContext';
import { useGetSettings } from 'src/features/administration/api/useGetSettings';
import SettingsContext from 'src/features/administration/context/SettingsContext';
import { Settings } from 'src/features/administration/utils/types';
import { LOCALE } from 'src/providers/types';
import { storage } from 'src/registry/utils/storage';

const defaultSettings: Settings = {
    languages: [LOCALE.EN, LOCALE.BG],
    default_language: 'en',
};

function SettingsProvider({ children }: { children: React.ReactNode }) {
    const { user, permissionsLoaded } = React.useContext(AuthContext);
    const { data: settings } = useGetSettings({ config: { enabled: !!user && permissionsLoaded } });

    React.useEffect(() => {
        if (settings && !storage.getLanguage()) {
            storage.setLanguage(settings.default_language);
        }
    }, [settings]);

    return <SettingsContext.Provider value={settings || defaultSettings}>{children}</SettingsContext.Provider>;
}

export { SettingsProvider };
